import { render } from "./Project-2.vue?vue&type=template&id=18a797cf"
import script from "./Project-2.vue?vue&type=script&lang=js"
export * from "./Project-2.vue?vue&type=script&lang=js"
script.render = render

export default script